import React, { useEffect, useState } from "react";
import S from "./EventCard.styled";
import Tag from "../Tag";
import { IWPEvent } from "@/src/types";
import { formatDate, toGatsbyImage } from "@/src/helpers";

export type EventCardProps = {
  eventsInfo: IWPEvent;
  uri: string;
  title: string;
  type?: string;
  hasThumbnail?: "image" | "thumbnail";
};

const EventCard: React.FC<EventCardProps> = ({
  eventsInfo: {
    tag,
    wysiwygContent,
    videoUrl,
    datepicker,
    datepickerEnd,
    image,
  },
  uri,
  title,
  type = "big",
  hasThumbnail,
}) => {
  const [thumbnailUrl, setThumbnailUrl] = useState("");
  const imageData = toGatsbyImage(image);

  useEffect(() => {
    if (!videoUrl) return;
    const parts = videoUrl.split("/");

    const videoId = parts[4].split("?")[0];

    fetch(`https://vimeo.com/api/v2/video/${videoId}.json`)
      .then((response) => response.json())
      .then((data) => {
        const thumbnail = data[0].thumbnail_large;
        setThumbnailUrl(thumbnail);
      })
      .catch((error) => console.error("Error fetching Vimeo video:", error));
  }, []);

  return (
    <S.Card to={uri} $type={type}>
      {hasThumbnail === "image" && imageData ? (
        <S.CardImage image={imageData} alt={image.altText || ""} />
      ) : (
        <S.CardVideo src={thumbnailUrl} />
      )}
      <S.CardInfo>
        <Tag tag={tag} />
        <S.CardDetails>
          {formatDate(datepicker, true)}
          {datepickerEnd && <> - {formatDate(datepickerEnd, true)}</>}
        </S.CardDetails>
      </S.CardInfo>
      <S.TextWrapper>
        {title && <S.CardTitle>{title}</S.CardTitle>}
        {wysiwygContent && (
          <S.CardIngress dangerouslySetInnerHTML={{ __html: wysiwygContent }} />
        )}
        <S.CardLink>Läs mer</S.CardLink>
      </S.TextWrapper>
    </S.Card>
  );
};

export default EventCard;
